import { system } from '../theme';

import { luxurySystem } from './luxury';

import type { SystemContext } from '@chakra-ui/react';

export const THEME_NAMES = ['default', 'luxury'] as const;

export type ThemeName = (typeof THEME_NAMES)[number];

export const themes: Readonly<Record<ThemeName, SystemContext>> = {
  default: system,
  luxury: luxurySystem,
};

/**
 * Tenant / customer IDs that use a non-default design theme.
 * Unlisted IDs (and null/undefined) resolve to `default`.
 */
export const tenantThemes: Readonly<Record<string, ThemeName>> = {
  // Example: 'tenant-uuid': 'luxury',
  '019f8fd6-e3b0-7a4d-b4e7-fed4605bab86': 'luxury',
};

export function getTheme(name: ThemeName): SystemContext {
  return themes[name];
}

export function getThemeForTenant(tenantId: string | null): ThemeName {
  if (!tenantId) {
    return 'default';
  }
  return tenantThemes[tenantId] ?? 'default';
}

export function isThemeName(value: unknown): value is ThemeName {
  return typeof value === 'string' && THEME_NAMES.includes(value as ThemeName);
}
